export const menuConfig = [
  { path: "/dashboard", permission: { module: "DASHBOARD", action: "VIEW" } },
  { path: "/trips", permission: { module: "TRIPS", action: "VIEW" } },
  { path: "/attendants", permission: { module: "ATTENDANTS", action: "VIEW" } },
  { path: "/travellers", permission: { module: "TRAVELLERS", action: "VIEW" } },
  { path: "/mostvisitedplaces", permission: { module: "MOST_VISITED_PLACES", action: "VIEW" } },
  { path: "/countries", permission: { module: "COUNTRIES", action: "VIEW" } },
  { path: "/states", permission: { module: "STATES", action: "VIEW" } },
  { path: "/cities", permission: { module: "CITIES", action: "VIEW" } },
  { path: "/languageinterface", permission: { module: "LANGUAGE_INTERFACE", action: "VIEW" } },
  { path: "/chats", permission: { module: "CHATS", action: "VIEW" } },
  { path: "/refer-commission-and-discount-history", permission: { module: "REFERRAL_DISCOUNT", action: "VIEW" } },
  { path: "/finance", permission: { module: "FINANCE", action: "VIEW" } },
  { path: "/adminmessages", permission: { module: "ADMIN_MESSAGES", action: "VIEW" } },
  { path: "/hotel&airbnb", permission: { module: "HOTEL_AIRBNB", action: "VIEW" } },
  { path: "/tripmedia", permission: { module: "TRIP_MEDIA", action: "VIEW" } }
];
